// 路由示例
import type { RouteRecordRaw } from "vue-router";
import { RouterName } from "@/enums/RouterEnum";
import { t } from "@/plugins/i18n";

const LoginRoutes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: RouterName.LOGIN,
    // component: () => import("@/views/login/index.vue"),
    component: () => import("@/views/login/empty.vue"),
    meta: {
      title: t("routes.login"),
    },
  },
  {
    path: "/weixin-page",
    name: RouterName.WEIXIN_PAGE,
    component: () => import("@/views/h5/Login.vue"),
    meta: {
      title: "登录-典枢",
      hideFloatingService: true,
    },
  },
  {
    path: "/weixin-pay",
    name: RouterName.WEIXIN_PAY,
    component: () => import("@/views/h5/PayNew.vue"),
    meta: {
      title: "支付-典枢",
      hideFloatingService: true,
    },
  },
  {
    path: "/weixin-api-pay",
    name: RouterName.WEIXIN_API_PAY,
    component: () => import("@/views/h5/ApiPayNew.vue"),
    meta: {
      title: "支付-典枢",
      hideFloatingService: true,
    },
  },
];

export default LoginRoutes;
